export default __webpack_public_path__ + "static/media/edit.e5e1d4a0.svg";